export enum ShowOrderCodeType {
	ExternalId = 0,
	FriendlyCode = 1,
	SellerOrderId = 2,
}
